<template>
    <v-dialog
            :value="!!value"
            :retain-focus="false"
            persistent
            max-width="800"
    >
        <v-form
                v-model="validForm"
                ref="form"
                @submit.prevent="submit"
        >
            <v-card
                    :loading="loading > 0"
                    :disabled="loading > 0"
            >
                <v-card-title class="grs-card-title px-0">
                    <span> {{ $t('connector_form_title') }} </span>

                    <v-spacer></v-spacer>

                    <v-btn
                            text
                            small
                            icon
                            @click="$emit('close')"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0">
                    <v-text-field
                            v-model="value.caption"
                            :label="$t('caption')"
                            :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                            v-model="value.code"
                            :label="$t('connector_code')"
                            :rules="[rules.required]"
                            class="ltr"
                    ></v-text-field>

                    <v-autocomplete
                            v-model="value.user_id"
                            :items="activeUsers"
                            item-text="full_name"
                            autocomplete="off"
                            item-value="id"
                            :loading="fetchingUsers"
                            :label="$t('user')"
                    ></v-autocomplete>
                    <v-text-field
                            v-model="value.reseller_id"
                            :label="$t('reseller_id')"
                            class="ltr"
                    ></v-text-field>
                </v-card-text>

                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>

                    <v-btn
                            color="secondary"
                            text
                            class="px-4"
                            @click="$emit('close')"
                    >{{$t('cancel')}}</v-btn>

                    <v-btn
                            color="primary"
                            class="px-4"
                            type="submit"
                    >
                        {{$t('submit')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import {mapActions, mapGetters } from 'vuex';

    import { required, mobile, password } from '@/scripts/validationRules';
    import Service from "../services/ConnectorsService";

    export default {
        props: {
            item : {
                required: true
            }
        },
        computed : {
            ...mapGetters({
                fetchingUsers: 'users/fetching',
                activeUsers: 'users/activeUsers',
            }),
        },
        data() {
            return {
                validForm: false,
                loading: 0,
                value : {...this.item},
                rules: {
                    required,
                    mobile,
                    password
                },

            }
        },
        created(){
            if(this.activeUsers.length <= 0){
                this.syncUsers();
            }

        },
        methods: {
            ...mapActions({
                syncUsers: 'users/fetchUsers'
            }),

            async submit() {
                if(!this.validForm) {
                    return this.$refs.form.validate();
                }

                try {
                    this.loading++;

                    let {
                        data
                    } = this.value.id ? await Service.update(this.value) : await Service.create(this.value);
                    this.$emit('submit', data);

                    this.$notify({
                        group: 'formGroup',
                        type: 'success',
                        title: data.message,
                    });

                } finally {
                    this.loading--;
                }

                this.$emit('close');
            }
        }
    }
</script>